import React, { useEffect, useMemo, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@mui/material/IconButton';
import API from '../../../../create/api';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment-timezone';
import querystring from 'querystring';
import { useSelector, useStore } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import * as helper from '../../../../../helper/index';
import Area from '../../../../fields/area';
import Company from '../../../../fields/company';
import Rider from '../../../../fields/rider';
import LinearProgress from '@mui/material/LinearProgress';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { type SelectChangeEvent } from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import LoadingButton from '@mui/lab/LoadingButton';
import FooterCalculator from './table.footer-calculator';
import { updateLastCompanyAndClearParcelIds } from '../../../../../store/thunk-actions';
import { type AnyAction } from 'redux';
import AddToPaymentCart from './table.button.add-to-payment';
import AddToPaymentCartBulk from './table.button.add-to-payment.bulk';
import DeleteParcel from './table.button.delete-parcel';
import AddtoBalance from './table.button.add-to-balance';
import AddtoBalanceBulk from './table.button.add-to-balance.bulk';
import ReturnedToMerchant from './table.button.returne-to-merchant';
import ReturnedToMerchantBulk from './table.button.returne-to-merchant.bulk';
import PaginationRow from './table.pagination';
import SetRider from './table.button.set-rider.bulk';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  fromControl: {
    width: '100%',
  },
  createButton: {
    paddingBottom: theme.spacing(2),
  },
  centerAlign: {
    textAlign: 'center',
    'span &': {
      verticalAlign: 'middle',
    },
  },
  onlyPrint: { display: 'none' },
  hidePrint: {},
  '@media print': {
    hidePrint: {
      display: 'none',
    },
    onlyPrint: { display: 'block' },
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function SpanningTable() {
  const classes = useStyles();

  const store = useStore();
  // first fetch
  const [loading, set_loading] = useState(false);
  const [checkbox, setcheckbox]: [Record<string, boolean>, any] = useState({});
  const [rows, setRows]: [any[], any] = useState([]);
  const [getInbalance, setInbalance]: [any, any] = useState(null);

  type ParcelDate = { startDate?: string; endDate?: string };
  const [get_parcel_date, set_parcel_date] = useState<ParcelDate>({});
  const [company, setCompany]: any = useState(store.getState().parcel?.last_company);

  const currentCompany = useSelector((state: any) => state?.parcel?.last_company);

  // table filter
  // let [company, setCompany]: any = React.useState(store.getState().parcel?.last_company);
  const [area, setArea]: any = useState(null);
  const [get_status, set_status]: any = React.useState([]);
  const [rider, setRider]: any = useState(null);

  const [get_search, set_search] = useState('');
  const [get_payment_date, set_payment_date] = useState(moment().format('YYYY-MM-DD'));

  const [get_total_parcel_count, set_total_parcel_count] = useState(0);

  const [paymentNull, setPaymentNull] = useState<null | boolean>(null);

  const limit = useSelector((state: any) => state?.parcel?.parcelTableLimit);
  const sortBy = useSelector((state: any) => state?.parcel?.parcelTableSort);
  const page = useSelector((state: any) => state?.parcel?.parcelTablePage);

  const totalSelected = useMemo(() => Object.values(checkbox).filter((val) => val).length ?? 0, [checkbox]);

  function updateParcel(id: number, data: any) {
    const newRows = [...rows];
    const index = newRows.findIndex((r) => r.id === id);
    newRows[index] = { ...newRows[index], ...data };
    setRows(newRows);
  }

  async function getParcel() {
    if (loading) return;

    set_loading(true);
    setcheckbox({});

    function date_filter() {
      if (get_parcel_date.startDate && !get_parcel_date.endDate) {
        return {
          booking_date_gte: moment(get_parcel_date.startDate).format('YYYY-MM-DD'),
          booking_date_lt: moment(get_parcel_date.startDate).add(1, 'd').format('YYYY-MM-DD'),
          _start: (page - 1) * 1000,
          _limit: limit,
        };
      }

      if (get_parcel_date.startDate && get_parcel_date.endDate) {
        return {
          booking_date_gte: moment(get_parcel_date.startDate).format('YYYY-MM-DD'),
          booking_date_lt: moment(get_parcel_date.endDate).add(1, 'd').format('YYYY-MM-DD'),
          _start: (page - 1) * limit,
          _limit: limit,
        };
      }

      return {
        _start: (page - 1) * limit,
        _limit: limit,
      };
    }

    const set_date_filter = date_filter();

    let paramObj: Record<string, any> = {
      _q: get_search,
      company: company?.value,
      area: area?.value,
      ...(get_status.length ? { status_in: get_status } : {}),
      rider: rider?.value,
      _sort: sortBy,
      ...set_date_filter,
    };

    paramObj = _.pickBy(paramObj, _.identity);

    if (getInbalance !== null) {
      paramObj.addToBalance = getInbalance;
    }

    // Add payment_null filter if selected
    if (paymentNull !== null) {
      paramObj.payment_null = paymentNull;
    }

    const param = querystring.encode(paramObj);

    const [parcels_payments, parcel_count]: any[] = await Promise.all([
      API.getAll(`${process.env.REACT_APP_API_SERVER}/parcels?${param}`),
      API.count(`${process.env.REACT_APP_API_SERVER}/parcels/count?${param}`),
    ]);
    set_total_parcel_count(parcel_count);
    set_loading(false);

    setRows(parcels_payments);
  }

  useEffect(() => {
    getParcel();
  }, [page, limit, sortBy]);

  // checkbox function
  const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    setcheckbox({ ...checkbox, [event.target.name]: event.target.checked });
  };

  const allSelectedCheck = useMemo(
    () => Object.values(checkbox).filter((val) => val).length === rows.length,
    [rows, checkbox],
  );
  const selectedParcels = useMemo(
    () =>
      Object.entries(checkbox)
        .filter(([, val]) => val)
        .map(([key]) => key.split('-')[1])
        .map((id) => rows.find((r) => r.id === parseInt(id))),
    [checkbox, rows],
  );

  // check all parcel
  const checkAllParcel = (event: React.ChangeEvent<HTMLInputElement>) => {
    let update = { ...checkbox };
    for (let i = 0; i < rows.length; i++) {
      update = { ...update, [`checkbox-${rows[i].id}`]: event.target.checked };
    }
    setcheckbox(update);
  };

  const [statusIDSetAction, setstatusIDSetAction]: [string, any] = useState('');
  async function updateCheckboxStatus() {
    for (let i = 0; i < Object.entries(checkbox).length; i++) {
      const [parcelID, value] = Object.entries(checkbox)[i];
      try {
        if (value && statusIDSetAction) {
          await axios.put(
            `${process.env.REACT_APP_API_SERVER}/parcels/${parcelID.split('-')[1]}`,
            {
              status: statusIDSetAction,
              ...(statusIDSetAction && ['DELIVERED', 'RETURNED', 'PARTIALLY_DELIVERED'].includes(statusIDSetAction)
                ? { payment_date: get_payment_date }
                : {}),
            },
            {
              headers: {
                Authorization: `Bearer ${store.getState().auth.jwt}`,
              },
            },
          );

          toastr.success(
            'Parcel Updated',
            `Parcel ID:${parcelID?.split('-')?.[1] ?? ''} Status to ${statusIDSetAction} updated`,
          );
          setcheckbox({});
          setstatusIDSetAction(null);
        }
      } catch (error: any) {
        helper.axiosErrorHandling(error);
      }
    }
    getParcel();
  }

  const handlePrint = () => {
    store.dispatch({ type: 'CLOSE_SIDEBAR' });
    setTimeout(() => {
      window.print();
    }, 100);
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12} className={classes.createButton}>
          {loading && <LinearProgress />}
        </Grid>

        <Grid
          container
          rowSpacing={{ xs: 4, sm: 4, md: 1 }}
          columnSpacing={{ xs: 1, sm: 2, md: 2 }}
          className={classes.hidePrint}
        >
          <Grid item xs={12} md={3} className={classes.hidePrint}>
            <TextField
              disabled={loading}
              label="Search"
              fullWidth
              variant="standard"
              onChange={(e) => {
                set_search(e?.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} md={3} className={classes.hidePrint}>
            Start:
            <TextField
              label=""
              type="date"
              fullWidth
              variant="standard"
              value={get_parcel_date.startDate}
              onChange={(e) => {
                let newDate: ParcelDate = {};
                if (moment(e.target.value).isValid()) {
                  newDate = {
                    ...get_parcel_date,
                    startDate: moment(e.target.value).format('YYYY-MM-DD').toString(),
                  };
                } else {
                  newDate = { startDate: undefined, endDate: undefined };
                }
                set_parcel_date(newDate);
              }}
              inputRef={(input) => {
                // Store ref for later use if needed
                if (input) {
                  (input as HTMLInputElement).showPicker = (input as HTMLInputElement).showPicker || (() => {});
                }
              }}
              onClick={(e) => {
                const input = e.target as HTMLInputElement;
                if (input && typeof input.showPicker === 'function') {
                  input.showPicker();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={3} className={classes.hidePrint}>
            End:
            <TextField
              label=""
              type="date"
              fullWidth
              variant="standard"
              disabled={!get_parcel_date.startDate}
              value={get_parcel_date.endDate ?? ''}
              onChange={(e) => {
                let newDate: ParcelDate = {};
                if (moment(e.target.value).isValid()) {
                  newDate = {
                    ...get_parcel_date,
                    endDate: moment(e.target.value).format('YYYY-MM-DD').toString(),
                  };
                } else {
                  newDate = { ...get_parcel_date, endDate: undefined };
                }
                set_parcel_date(newDate);
              }}
            />
          </Grid>
          <Grid item xs={12} md={3} className={classes.hidePrint}>
            Balance
            <Select
              disabled={loading}
              label="Balance"
              fullWidth
              variant="standard"
              className={classes.fromControl}
              value={getInbalance}
              onChange={(e) => {
                setInbalance(e.target.value);
              }}
            >
              {[
                { label: 'None', value: null },
                { label: 'In Balance', value: true },
                { label: 'Not In Balance', value: false },
              ].map((v: any, index: number) => (
                <MenuItem key={`${v.label}-${index}-Select-item`} value={v.value}>
                  {v.label}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12} md={3} className={classes.hidePrint}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id="demo-multiple-chip-label">Status</InputLabel>
              <Select
                disabled={loading}
                variant="standard"
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                value={get_status}
                onChange={(event: SelectChangeEvent) => {
                  const {
                    target: { value },
                  } = event;
                  set_status(typeof value === 'string' ? value.split(',') : value);
                }}
                input={<Input id="select-multiple-chip" />}
                renderValue={(selected) => {
                  return (selected as unknown as unknown[] as string[]).map((value) => (
                    <Chip key={value} label={value} />
                  ));
                }}
                MenuProps={MenuProps}
              >
                {store.getState().parcel?.parcelStatus?.map((v: any, index: number) => (
                  <MenuItem key={`${v.label}-${index}-Select-item`} value={v.value}>
                    {v.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} className={classes.hidePrint}>
            <Company
              disabled={loading}
              onChange={(cp: any) => {
                setCompany(cp ?? null);
                store.dispatch(updateLastCompanyAndClearParcelIds(cp) as unknown as AnyAction);
              }}
              defaultValue={store.getState().parcel?.last_company}
            />
          </Grid>
          <Grid item xs={12} md={3} className={classes.hidePrint}>
            <Area disabled={loading} onChange={(cp: any) => setArea(cp ?? null)} />
          </Grid>
          <Grid item xs={12} md={3} className={classes.hidePrint}>
            <Rider disabled={loading} onChange={(cp: any) => setRider(cp ?? null)} />
          </Grid>
          {/* Payment null toggle filter */}
          <Grid item xs={12} md={3} className={classes.hidePrint}>
            <div className="flex flex-col w-full">
              <span className="text-sm mb-1">Payment</span>
              <ToggleButtonGroup
                value={paymentNull}
                exclusive
                size="small"
                onChange={(e, val) => {
                  // Allow deselect to go back to all (null)
                  if (val === null) {
                    setPaymentNull(null);
                  } else if (val === paymentNull) {
                    setPaymentNull(null);
                  } else {
                    setPaymentNull(val);
                  }
                }}
                aria-label="payment null filter"
                className="flex flex-wrap payment-toggle"
              >
                <ToggleButton
                  value={false}
                  aria-label="has payment"
                  disabled={loading}
                  className={`normal-case text-xs px-3 py-1 rounded border border-gray-300 transition-colors ${
                    paymentNull === false ? '!bg-green-600 !text-white' : ''
                  }`}
                >
                  Paid
                </ToggleButton>
                <ToggleButton
                  value={true}
                  aria-label="payment missing"
                  disabled={loading}
                  className={`normal-case text-xs px-3 py-1 rounded border border-gray-300 transition-colors ${
                    paymentNull === true ? '!bg-red-600 !text-white' : ''
                  }`}
                >
                  Not Paid
                </ToggleButton>
              </ToggleButtonGroup>
            </div>
          </Grid>
          <Grid item xs={12} md={3} className={classes.hidePrint}>
            {loading ? (
              <LoadingButton loading variant="contained" loadingPosition="end">
                Searching..
              </LoadingButton>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={async () => {
                  await getParcel();
                }}
              >
                Search
              </Button>
            )}
          </Grid>
          <Grid item xs={12} md={3} className={classes.hidePrint}>
            <SetRider loading={loading} parcels={selectedParcels} refreshParcel={getParcel} />
          </Grid>
          <Grid item xs={12} md={3} className={classes.hidePrint}>
            <span>Set Status</span>
            <Select
              disabled={loading}
              label="Status"
              fullWidth
              variant="standard"
              className={classes.fromControl}
              value={statusIDSetAction}
              onChange={(e) => {
                const status: any = e.target.value ?? '';
                setstatusIDSetAction(status);
              }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {store.getState().parcel?.parcelStatus?.map((v: any, index: number) => (
                <MenuItem key={`${v.label}-${index}-Select-item`} value={v.value}>
                  {v.label}
                </MenuItem>
              ))}
            </Select>
            {statusIDSetAction && ['DELIVERED', 'PARTIALLY_DELIVERED', 'RETURNED'].includes(statusIDSetAction) ? (
              <TextField
                label=""
                type="date"
                fullWidth
                variant="standard"
                value={get_payment_date}
                onChange={(e) => {
                  set_payment_date(moment(e.target.value).format('YYYY-MM-DD').toString());
                }}
              />
            ) : (
              ''
            )}
            <Button
              color="primary"
              onClick={() => {
                updateCheckboxStatus();
              }}
              variant="contained"
              size="small"
              disabled={loading || !statusIDSetAction}
            >
              Set Status
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.createButton}>
          <style>{'@media print {.hidePrint{display: none;}}'}</style>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="a spanning dense table" padding="checkbox">
              <PaginationRow
                classes={classes}
                handlePrint={handlePrint}
                loading={loading}
                selected={totalSelected}
                total={get_total_parcel_count}
              />
              <TableHead>
                <TableRow style={{ backgroundColor: '#F8F9F9' }}>
                  <TableCell className={classes.hidePrint}>
                    <Checkbox checked={allSelectedCheck ?? false} onChange={checkAllParcel} />
                  </TableCell>
                  <TableCell>
                    <b>APN</b>
                  </TableCell>
                  <TableCell align="left">
                    <b>Company</b>
                  </TableCell>
                  <TableCell colSpan={2} align="center">
                    <b>Invoice</b>
                  </TableCell>
                  <TableCell align="left">
                    <b>Customer</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>Weight</b>
                  </TableCell>
                  <TableCell align="right">
                    <b>COD</b>
                  </TableCell>
                  <TableCell align="right">
                    <b>DC</b>
                  </TableCell>
                  <TableCell align="right">
                    <b>Collected</b>
                  </TableCell>
                  <TableCell align="right">
                    <b>Return</b>
                  </TableCell>
                  <TableCell align="right">
                    <b>RiderName</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>Status</b>
                  </TableCell>
                  <TableCell align="center" className={classes.hidePrint} style={{ whiteSpace: 'nowrap' }}>
                    <ReturnedToMerchantBulk parcels={selectedParcels} refreshParcel={getParcel} />
                    <AddToPaymentCartBulk parcels={selectedParcels} company={currentCompany} />
                    <AddtoBalanceBulk parcels={selectedParcels} refreshParcel={getParcel} />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row: any, index: number) => (
                  <React.Fragment>
                    <TableRow key={row.id}>
                      <TableCell className={classes.hidePrint}>
                        <Checkbox
                          name={`checkbox-${row.id}`}
                          checked={checkbox[`checkbox-${row.id}`] ?? false}
                          onChange={(e) => {
                            handleCheckBox(e, index);
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        {`${row.id} 
                          ${moment(row.booking_date).tz('Asia/Dhaka').format('DD/MMM/YY')}`}
                      </TableCell>
                      <TableCell align="center">
                        <span style={{ fontSize: '0.7em' }}>
                          <b>{row.company?.name}</b>
                        </span>
                      </TableCell>
                      <TableCell colSpan={2} align="center">
                        {['PAYMENT'].includes(row.status)
                          ? moment(row.created_at).tz('Asia/Dhaka').format('DD/MMM/YY')
                          : row.memoNo}
                      </TableCell>
                      <TableCell align="left">
                        {['PAYMENT'].includes(row.status) ? row.note : row.customerName}
                        <br />
                        {row.phoneNumber}
                      </TableCell>
                      <TableCell align="center">{row.weight}</TableCell>
                      <TableCell align="right">{row.merchant_COD ?? 0}</TableCell>
                      <TableCell align="right">{row.deliveryCharge ?? 0}</TableCell>
                      <TableCell align="right">{row.collected_amount ?? 0}</TableCell>
                      <TableCell align="right">{row.return_product_price}</TableCell>

                      <TableCell align="center">{row.rider?.name}</TableCell>
                      <TableCell align="center">
                        <span style={{ fontSize: '0.7em', whiteSpace: 'nowrap' }}>
                          <b>
                            {row.status?.replace('PARTIALLY_DELIVERED', 'P_DELIVERED')}
                            {row.status === 'RETURNED' && (
                              <ReturnedToMerchant
                                id={row.id}
                                returnToMerchant={row.returnToMerchant}
                                updateParcel={updateParcel}
                              />
                            )}
                          </b>
                        </span>
                      </TableCell>

                      <TableCell align="center" className={classes.hidePrint}>
                        <div style={{ whiteSpace: 'nowrap' }}>
                          <AddToPaymentCart
                            id={row.id}
                            addToBalance={row.addToBalance}
                            company={currentCompany}
                            payment={row.payment}
                          />
                          <AddtoBalance id={row.id} addToBalance={row.addToBalance} updateParcel={updateParcel} />
                          <IconButton
                            color="success"
                            onClick={() =>
                              ['PAYMENT'].includes(row.status)
                                ? window.open(`/dashboard/payment/edit/${row.id}`)
                                : window.open(`/dashboard/parcel/edit/${row.id}`)
                            }
                          >
                            <EditIcon />
                          </IconButton>
                          <DeleteParcel addToBalance={row.addToBalance} id={row.id} refreshParcel={getParcel} />
                        </div>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left" colSpan={2}></TableCell>
                      <TableCell align="left" colSpan={5}>
                        {row.type === 'parcel' &&
                          row?.parcel_logs
                            .filter((log: { type: string }) => log.type === 'comment')
                            .map((log: any, i: number) => (
                              <div key={i}>
                                {moment(log.created_at).format('DD/MMM')}
                                {': '}
                                <b> {log.details}</b>
                              </div>
                            ))}
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
                <FooterCalculator classes={classes} rows={rows} />
              </TableBody>{' '}
              <PaginationRow
                classes={classes}
                handlePrint={handlePrint}
                loading={loading}
                selected={totalSelected}
                total={get_total_parcel_count}
              />
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
}
